import { Sparkles } from "lucide-react";

export function AICard({ title = "AI Summary", children, footer, className = "" }) {
  return (
    <div className={`rounded-xl border border-violet-200 bg-violet-50/70 p-4 ${className}`}>
      <div className="flex items-center gap-2 mb-2">
        <div className="h-6 w-6 rounded-md bg-violet-600 flex items-center justify-center">
          <Sparkles className="h-3.5 w-3.5 text-white" strokeWidth={2} />
        </div>
        <span className="text-xs font-semibold uppercase tracking-wider text-violet-700">{title}</span>
      </div>
      <div className="text-sm leading-relaxed text-violet-950/90">{children}</div>
      {footer && <div className="mt-3 pt-3 border-t border-violet-200/70">{footer}</div>}
    </div>
  );
}

export function AIBadge({ children = "AI" }) {
  return (
    <span className="inline-flex items-center gap-1 px-1.5 py-0.5 rounded text-[10px] font-semibold bg-violet-100 text-violet-700 border border-violet-200">
      <Sparkles className="h-2.5 w-2.5" strokeWidth={2.5} />
      {children}
    </span>
  );
}
